import { all } from "redux-saga/effects"
import heroBannerSaga from "./BannerSaga"
import brandSaga from "./BrandSaga"
import CartListSaga from "./CartListSaga"
import categoryListSaga from "./CategorySaga"
import flagshipStoreSaga from "./FlagshipStoreSaga"
import forgetPasswordSaga from "./ForgetPasswordSaga"
import loginInfoSaga from "./loginInfoSaga"
import ProcessToCheckout from './ProcessToCheckoutSaga'
import productListSaga from "./ProductListSaga"
import resetPasswordSaga from "./ResetPasswordSaga"
import userInfoSaga from "./UserInfoSaga"
import userOtpSaga from "./UserOtpSaga"
import collectionListSaga from './CollectionListSaga'
import customerAddressSaga from './CustomerAddressSaga'
import countryListSaga from "./CountrylistSaga"
import customerProfileSaga from "./CustomerProfileSaga"
import customerOrderSaga from "./CustomerOrderSaga"
import customerVouchersApplySaga from "./CustomerVouchersApplySaga"
import customerCartSaga from "./CustomerCartSaga"
import customerWishListSaga from "./CustomerWishListSaga"
import customerCollectionSaga from "./CustomerCollectionSaga"
import searchSuggestSaga from "./SearchSuggestSaga"
import searchResultsSaga from "./SearchResultsSaga"



export default function* rootSaga() {
    yield all([
        userInfoSaga(),
        userOtpSaga(),
        loginInfoSaga(),
        heroBannerSaga(),
        flagshipStoreSaga(),
        brandSaga(),
        forgetPasswordSaga(),
        resetPasswordSaga(),
        productListSaga(),
        categoryListSaga(),
        CartListSaga(),
        ProcessToCheckout(),
        collectionListSaga(),
        customerAddressSaga(),
        countryListSaga(),
        customerProfileSaga(),
        customerOrderSaga(),
        customerVouchersApplySaga(),
        customerCartSaga(),
        customerWishListSaga(),
        customerCollectionSaga(),
        searchSuggestSaga(),
        searchResultsSaga(),


    ])
}
